export default __webpack_public_path__ + "fc87d1543dc21afb680c21e2c50dc64d.svg";